'use client';

import { clsx } from 'clsx';
import { FC, PropsWithChildren } from 'react';
import { Drawer } from 'atoms/Drawer';
import { usePopoverManager } from 'modules/shop/popoverManager/hooks';
import { PopoverType } from 'modules/shop/popoverManager/types';
import { SidebarContent } from './SidebarContent';
import styles from './styles.module.css';

export const Sidebar: FC<PropsWithChildren> = ({ children }) => {
  const { activePopover, closePopover } = usePopoverManager();
  const isSidebarOpen = activePopover === PopoverType.SIDEBAR;

  return (
    <div className={clsx(styles.root, isSidebarOpen && styles.sidebarOpened)}>
      <Drawer
        open={isSidebarOpen}
        classes={{ paper: styles.drawer }}
        onClose={closePopover}
      >
        <SidebarContent />
      </Drawer>
      <div
        className={clsx(styles.content, isSidebarOpen && styles.contentMoved)}
      >
        {children}
      </div>
    </div>
  );
};
